import React, { useEffect, useRef, useState } from 'react';
import '../../css/MessageSection.css';

function AnimatedLine({ children, delay }) {
  return (
    <p
      className="text-xl md:text-2xl font-normal tracking-wide leading-relaxed opacity-0 animate-fade-in-line whitespace-pre-line"
      style={{
        animationDelay: `${delay}s`,
        animationFillMode: 'forwards',
        animationDuration: '0.8s',
        animationTimingFunction: 'ease-out',
      }}
    >
      {children}
    </p>
  );
}

function MessageSection() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    let hasAppeared = false;
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAppeared) {
          setShouldAnimate(true);
          setVisible(true);
          hasAppeared = true;
        }
      },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const lines = [
    <span className="font-bold text-orange-400">考え、挑み、成長し続ける人へ。</span>,
    'シャルンでは多様な現場で磨いたスキルを武器に、キャリアを無限に広げていくことができます。',
    '年齢や社歴に関係なく、チャンスは平等にあります。',
    '20代で役員に就任し経営層への道や、支援を受けて起業するなど—',
    '「どうすればもっと良くなるか」を自ら考え、',
    '試行錯誤を楽しむ姿勢が新しい可能性を切り拓きます。',
    '主体的に動く人ほど、大きく成長できるフィールドがここにはあります。'
  ];

  return (
    <section
      ref={ref}
      className={`relative message-clipped-section ${visible ? 'line-animate' : ''} ${visible ? 'opacity-100' : 'opacity-0'}   bg-black backdrop-blur-md text-white p-6 md:p-12`}
      style={{
        willChange: 'opacity',
        transition: shouldAnimate
          ? 'opacity 1.2s cubic-bezier(.4,0,.2,1)'
          : 'none',
        minHeight: '150vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center'
      }}
      onTransitionEnd={() => setShouldAnimate(false)}
    >
      <video
        className="absolute inset-0 w-full h-full object-cover -z-10"
        src={`${process.env.PUBLIC_URL}/video/circle2.mp4`}
        autoPlay
        loop
        muted
        playsInline
      />
      <h2 id="message" className="text-3xl md:text-5xl font-black tracking-tight mb-12 border-b border-white/100 pb-2">
        Message
      </h2>
      <div className="space-y-4">
        {visible &&
          lines.map((line, i) => (
            <AnimatedLine key={i} delay={i * 0.6}>
              {line}
            </AnimatedLine>
          ))}
      </div>
    </section>
  );
}

export default MessageSection;
